module.exports = __webpack_public_path__ + "static/media/ucsd_logo.71299e48.png";